const ScrollAnchor = () => (
  <section className="bg-accent/40 py-16">
    <div className="reading-column px-6 text-center">
      <hr className="mx-auto mb-8 w-16 border-t border-border" />
      <p className="font-serif text-2xl italic leading-relaxed text-foreground sm:text-3xl">
        If you've stayed with me this far…
        <br />
        <a href="#reset" className="text-primary underline-offset-4 hover:underline">
          you might want to stay connected.
        </a>
      </p>
      <hr className="mx-auto mt-8 w-16 border-t border-border" />
    </div>
  </section>
);

export default ScrollAnchor;
